import apiConfig from "constants/apiConfig";
import { Collaboration, Collaborations, Milestone, MilestoneData, ProcessMilestonePayload } from "types/campaign/collaborations";
import axiosClient from "utils/axiosClient";

export const fetchCollaborations = async (agencyId: string, campaignId: string, payload: any): Promise<Collaborations> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_COLLABORATIONS.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId), { params: payload });

    return response.data;
}

export const fetchCollaboration = async (agencyId: string, campaignId: string, collaborationId: string): Promise<{ collaboration: Collaboration, milestones: Milestone[], chat: {uuid: string} | null }> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_COLLABORATION.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<collaborationId>', collaborationId));

    return response.data;
}

export const fetchCollaborationBasic = async (agencyId: string, campaignId: string, collaborationId: string): Promise<{ collaboration: Collaboration, milestones: Milestone[], chat: {uuid: string} | null }> => {
    const response = await axiosClient.get(apiConfig.FETCH_CAMPAIGN_COLLABORATION_BASIC.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<collaborationId>', collaborationId));

    return response.data;
}

export const processCollaboration = async (agencyId: string, campaignId: string, influencerId: string, payload: any): Promise<any> => {
    const response = await axiosClient.put(apiConfig.PROCESS_COLLABORATION.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId), payload);

    return response.data;
}

export const fetchCollaborationMilestone = async (agencyId: string, campaignId: string, influencerId: string, milestoneId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABORATION_MILESTONE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId)
        .replace('<milestoneId>', milestoneId)
    );

    return response.data as MilestoneData
}

export const submitStepDeadline = async (agencyId: string, campaignId: string, influencerId: string, stepSlug: string | number, date: string) => {
    const response = await axiosClient.post(apiConfig.SUBMIT_STEP_DEADLINE.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId)
        .replace('<stepSlug>', String(stepSlug)),
        {date}
    );

    return response.data;
}

export const acknowledgeStep = async (agencyId: string, campaignId: string, influencerId: string, stepSlug: string | number,) => {
    const response = await axiosClient.post(apiConfig.ACKNOWLEDGE_STEP.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId)
        .replace('<stepSlug>', String(stepSlug)),
    );

    return response.data;
}

export const fetchAllCollaborations = async (agencyId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_ALL_COLLABORATIONS.url.replace('<agencyId>', agencyId), { params: payload });
    return response.data;
}

export const processCollaborationMilestoneStep = async (agencyId: string, campaignId: string, influencerId: string, milestoneId: string, payload: ProcessMilestonePayload) => {

    const formData = new FormData();

    for (let [key, value] of Object.entries(payload)) {
        const formValue = Array.isArray(value) ? value.join(',') : value;
        formData.append(key, formValue);
    }

    const response = await axiosClient.post(apiConfig.PROCESS_COLLABORATION_MILESTONE_STEP.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId)
        .replace('<milestoneId>', milestoneId),
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

    return response.data;
}

export const processCollaborationMilestoneMedia = async (agencyId: string, campaignId: string, influencerId: string, milestoneId: string, payload: ProcessMilestonePayload) => {
    
    const formData = new FormData();

    for (let [key, value] of Object.entries(payload)) {
        const formValue = Array.isArray(value) ? value.join(',') : value;
        formData.append(key, formValue);
    }

    const response = await axiosClient.post(apiConfig.PROCESS_COLLABORATION_MILESTONE_STEP.url.replace('<agencyId>', agencyId)
        .replace('<campaignId>', campaignId)
        .replace('<influencerId>', influencerId)
        .replace('<milestoneId>', milestoneId),
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

    return response.data;
}

export const fetchCollaborationTasksSummary = async (agencyId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABS_SUMMARY.url.replace('<agencyId>', agencyId));
    return response.data;
}

export const fetchBulkProcessEligibleGigSteps = async (gigType: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_ELIGIBLE_GIG_STEP_BP.url, {params:  {gig_type: gigType, allow_bulk_process: 'y'}});
    return response.data?.results ?? [];
}

export const fetchBulkProcessCollabData = async (agencyId: string, campaignId: string, milestoneId: number, gigStep: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_COLLABS_DATA_BP.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId).replace('<milestoneId>', String(milestoneId)).replace('<gigStep>', gigStep));
    return response.data.items ?? [];
}

export const addCollaborationPayment = async (agencyId: string, campaignId: string, collaborationId: string, amount: number) => {
    const response = await axiosClient.post(apiConfig.ADD_COLLABORATION_PAYMENT.url.replace('<agencyId>', agencyId).replace('<campaignId>', campaignId).replace('<collaborationId>', collaborationId), {amount});
    return response.data;
}